 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HouseholdAdd',
	};
	var client_ids = [];

	Adzuki.onload('Households/add', init);

	function init() {

		Adzuki.Form.registerForm(form);

		// resets status text next to opt-ins checkBoxes
		$(".reset-typeahead").click(function reset(e) {
			var $self       = $(this),
			    $parent     = $self.parentsUntil(".new-existing-client"),
			    $opt_index = $parent.find(".existing_opted_in .weekly-opt").data('array');

			e.preventDefault();

			$('#household-client-' + $opt_index + ' .existing_opted_in .weekly-opt').text("");
			$('#household-client-' + $opt_index + ' .existing_luxury_opted_in .luxury-opt').text("");

		});

		$('#component_existing_client_btn').click(function clicked() {
			if (client_ids.length === 0) {
				$('#address_select_section').addClass('hidden');
			} else {
				$('#address_select_section').removeClass('hidden');
			}
		});
		
		$('#component_new_client_btn').click(function clicked() {
			$('#address_select_section').addClass('hidden');
		});
		
		$('.existing-client').on('ta.set-hidden', function add(e, value) {
			client_ids.push(value);
			getClientAddress();
		});
		
		$('.existing-client').on('ta.reset', function remove(e, value) {
			let index = client_ids.indexOf(value);
			if (index !== -1) {
				client_ids.splice(index, 1);
			}
			if (client_ids.length !== 0) {
				getClientAddress();
			}
			
			if (client_ids.length === 0) {
				setAdddressFields();
				$('#address_select_section').addClass('hidden');
			}
		});
		
		$('#householdadd-address_select').change(function change() {
			let client_id = $(this).val();
			
			if (client_id === '') {
				setAdddressFields();
			} else {
				Adzuki.Ajax.post('/Households/getClientAddress/',
					{ address_id: client_id }
				).then(function getAddressData(response) {
					setAdddressFields(
						response.address1,
						response.address2,
						response.city,
						response.state_id,
						response.country_id,
						response.zip,
					);
				});
			}
		});
		
		// shows the selected number of new or existing client forms
		$("#householdadd-number_of_clients").change(function numClients(event) {
			Adzuki.ClientNewOrExisting.toggleClientFields($('.new-household'), $(this).val());
		});

		// shows CC information on form for this particular client
		$(".toggle-cc").click(function showCC(event) {
			var $self   = $(this),
			    $parent = $self.closest('.form-group'),
			    $div    = $parent.siblings('.client-credit-card-info');

			$div.toggleClass('hidden');
		});

		// do we want to collect CC information that differs from the household address?
		$(".cc-use-household-address").click(function showCCBilling(event) {
			var $self   = $(this),
			    $parent = $self.closest('.client-credit-card-info'),
			    $div    = $parent.find('.client-credit-card-address');

			$div.toggleClass('hidden');
		});

		// shows passport information on form for this particular client
		$(".toggle-passport").click(function showCC(event) {
			var $self   = $(this),
				$parent = $self.closest('.form-group'),
				$div    = $parent.siblings('.client-passport-info');

			$div.toggleClass('hidden');
		});

		// copy first client's last name to other parts of the form
		$("#householdadd-neworexistingclient-0-newclient-new_client_last_name").on('keyup', function copyLastName() {
			var $self        = $(this),
			    $outer       = $self.closest('.new-household'),
			    $new_clients = $outer.find('.new-client-fields'),
			    last_name    = $self.val();

			// add to other client's last name field if they have "Same as client 1" checked
			$new_clients.each(function togg(i, obj) {
				var $element         = $(obj),
				    $last_name_field = $element.find(".last-name");

				if (i > 0) {
					$last_name_field.val(last_name);
				}
			});
		});

		// copy client's name to the "Name on Card" in case the agent is adding a CC too
		$(".first-name, .last-name").on('keyup', function fillCCName() {
			var $self          = $(this),
			    $parent        = $self.closest('.new-client-fields'),
			    $cc_name       = $parent.find('.credit-card-name'),
			    first_name_val = $parent.find('.first-name').val(),
			    last_name_val  = $parent.find('.last-name').val(),
			    name_str       = first_name_val;

			if (last_name_val.length > 0) {
				name_str += ' ' + last_name_val;
			}

			$cc_name.val(name_str);
		});


		// if the user modifies one of the address fields, we are going to set the hidden satori_updated field to 0
		// we are doing this because it's possible for the user to take the initial Satori suggestion, which would set satori_updated to 1, then
		// the system can recognize that the address is a dupe or Satori could catch an Address 2 issue and the submission would not go thru all the way
		// In that case, the user could modify the address again in the form, which could result in a bad address they force thru all together or a
		// pristine address that Satori does not modify at all. Either scenario, we should not flag the household as satori_updated
		$(".address-fields").on("change", "input, select", function changed(e)
		{
			var $self           = $(this),
			    $address_fields = $self.closest('.address-fields'),
			    $satori_updated = $address_fields.find('.satori-updated').find('input[type=hidden]');

			$satori_updated.val(0);
		});

		$(".credit-card-type").change(function ccChange(event) {
			var $self          = $(this),
			    $parent        = $self.closest('.client-credit-card-info'),
			    $cc_branch_row = $parent.find('.credit_card_type_branch_row'),
			    $branch_dd     = $cc_branch_row.find('select');

			// American Express
			if (parseInt($self.val()) === 1) {
				$cc_branch_row.removeClass('hidden');
				$branch_dd.prop('disabled', false);

			} else {
				$cc_branch_row.addClass('hidden');
				$branch_dd.prop('disabled', true);
			}

			Adzuki.CardNumberEntry.amexTokenization($self.closest('.new-client-fields'));
		});

		form.confirmation = function confirmation(response)
		{
			if (response.data.response_code === "duplicate_email") {
				Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);
			} else {
				Adzuki.Erez.Household.confirm(response, form.name);
			}
		};
	}
	
	/**
	 * Gets the clients addresses
	 */
	function getClientAddress() {
		$('#householdadd-address_select').html($('<option>',
			{
				value: '',
				text : 'Enter New Address'
			}));
		if (client_ids.length !== 0) {
			Adzuki.Ajax.post(
				'/Households/getClientAddresses/',
				{client_ids: client_ids}
			).then(function success(content) {
				let address_count = Object.keys(content).length;
				if (address_count > 0) {
					for (const [key, value] of Object.entries(content)) {
						if (value.single_line_address !== '') {
							$('#householdadd-address_select').append($('<option>', {
								value: key,
								text : value.single_line_address
							}));
						}
					}
					$('#address_select_section').removeClass('hidden');
				}
			});
		}
		if (client_ids.length === 0) {
			$('#address_select_section').addClass('hidden');
		}
	}
	
	/**
	 * Sets the pages field values
	 */
	function setAdddressFields(
		address1 = '',
		address2 = '',
		city = '',
		state_id = '',
		country_id = '',
		zip_code = ''
	)
	{
		$('#householdadd-addresses-0-address1').val(address1);
		$('#householdadd-addresses-0-address2').val(address2);
		$('#householdadd-addresses-0-city').val(city);
		$('#householdadd-addresses-0-state_id').val(state_id);
		$('#householdadd-addresses-0-country_id').val(country_id);
		$('#zipUpCap').val(zip_code);
	}

}(jQuery, window.Adzuki || {}));
